
import { axios, BaseApiUrl ,BaseRouterUrl} from '../axios_config';


export function GetShippingPlanList(params) {
    return axios.post(`${BaseApiUrl}/ShippingPlan/GetShippingPlanList`, params);
}



export const SynchroPackDataToBaiYi = params => {
    return axios.get(`${BaseApiUrl}/ShippingPlan/SynchroPackDataToBaiYi`, { params: params });
};

export function ShipplanOccTask(params) {
    return axios.post(`${BaseApiUrl}/ShippingPlan/ShippingPlanOccupy`, params);
}
export function ShipplanOccTaskBack(params) {
    return axios.post(`${BaseApiUrl}/ShippingPlan/ShippingPlanOccupyBack`, params);
}



export const ShippingPlanExport = `${BaseApiUrl}/ShippingPlan/ShippingPlanExport`;


export const skipWaitPickUrl = `${BaseRouterUrl}/Outbound/WaitPick`;


export function PlanUploadBarcode(params) {
    return axios.post(`${BaseApiUrl}/ShippingPlan/PlanUploadBarcode`, params);
}

export function CheckPlanBarcodeIsExist(params) {
    return axios.post(`${BaseApiUrl}/ShippingPlan/CheckPlanBarcodeIsExist`, params);
}

export const BatchDownloadBarCodeFile = params => {
    return axios.post(`${BaseApiUrl}/ShippingPlan/BatchDownloadBarCodeFile`, params);
};

export const PreviewsBarCodePDF = params => {
    return axios.get(`${BaseApiUrl}/ShippingPlan/PreviewsBarCodePDF`, { params: params });
};



export const editStockingPlanRelationByStatus = params => {
    return axios.post(`${BaseApiUrl}/ReadyforTask/EditStockingPlanRelationByStatus`,  params);
};
